import React from "react";
import "./Project.css";
import { FcViewDetails } from "react-icons/fc";
import { BsGithub } from "react-icons/bs";
import { MdLiveTv } from "react-icons/md";
import { Link } from "react-router-dom";

const Project = ({ project }) => {
  const { img, name, discription, live, github, id } = project;

  const liveSite = {
    href: live,
    target: "_blank",
  };

  const GithubSite = {
    href: github,
    target: "_blank",
  };

  return (
    <div
      className="card lg:w-96 bg-gray-300 text-black p-5 rounded-lg shadow-xl"
      data-aos="fade-right"
    >
      <div className="project-img rounded-md">
        <img className="h-64 w-full rounded-md" src={img} alt="project" />
      </div>
      <div className="card-body">
        <div className="card-title">
          <p className="font-semibold text-lg text-start">{name}</p>
        </div>
        <p className="font-sans">
          {discription.slice(0, 200)}
          <span className="font-bold text-indigo-600">.....</span>
        </p>
        <div className="details text-center flex justify-evenly items-center">
          <a
            className="text-black font-semibold flex items-center"
            {...GithubSite}
          >
            <BsGithub size={20} className="mr-1" />
            <p>GitHub</p>
          </a>
          <a
            className="text-indigo-600 font-semibold flex items-center"
            {...liveSite}
          >
            <MdLiveTv size={20} className="mr-1" />
            <span>Live</span>
          </a>
          <Link to={`/details/${id}`}>
            <button className="flex items-center font-semibold text-black">
              <FcViewDetails size={25} />
              <span>More Info</span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Project;
